<script setup>
import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import HelperTextPopup from 'dashboard/components/ui/HelperTextPopup.vue';
import {
  CONTACT_CLASSIFICATIONS,
  resolveContactClassification,
} from 'dashboard/constants/contactClassifications';

const props = defineProps({
  contactId: {
    type: Number,
    default: null,
  },
  classificationValue: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select']);

const INTERNAL_TEAM_INFO =
  'Identifica contatos que fazem parte da equipe interna, em vez de leads ou clientes.';

const store = useStore();

const contact = computed(() =>
  props.contactId ? store.getters['contacts/getContact'](props.contactId) : null
);
const classification = computed(() =>
  CONTACT_CLASSIFICATIONS.find(
    option => option.value === props.classificationValue
  )
);
const inputId = computed(
  () => `contact-classification-${props.contactId}-${props.classificationValue}`
);
const isSelected = computed(
  () =>
    resolveContactClassification(contact.value).value ===
    props.classificationValue
);

const selectClassification = () => {
  if (props.disabled) return;
  if (isSelected.value && props.classificationValue !== 'internal_team') return;

  emit('select', props.classificationValue);
};
</script>

<template>
  <div class="px-4 py-3">
    <div class="mb-1">
      <h4
        class="relative inline-flex items-center m-0 text-sm max-md:gap-2"
        :class="classificationValue === 'internal_team' ? 'pr-6' : ''"
      >
        <div class="flex items-center">
          <input
            :id="inputId"
            :checked="isSelected"
            :disabled="disabled"
            class="!my-0 relative top-px ltr:mr-2 ltr:ml-0 rtl:mr-0 rtl:ml-2"
            type="checkbox"
            @click.stop.prevent="selectClassification"
          />
        </div>
        <label
          :for="inputId"
          class="flex shrink-0 cursor-pointer items-center font-medium whitespace-nowrap text-sm text-n-slate-12"
        >
          <span class="inline-flex items-center gap-1.5">
            <Icon
              :icon="classification.icon"
              class="relative top-px size-4 flex-shrink-0"
            />
            <span>{{ classification.label }}</span>
          </span>
        </label>
        <HelperTextPopup
          v-if="classificationValue === 'internal_team'"
          :message="INTERNAL_TEAM_INFO"
          placement="right"
        />
      </h4>
    </div>
  </div>
</template>
